<template>
    <v-card class="elevation-12">
      <v-toolbar dark color="blue darken-3">
        <v-toolbar-title>회원가입</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card-text>
          <v-form>
            <v-text-field required prepend-icon="person" name="login" v-model="email" label="이메일"  :rules="emailRules" type="text" autocomplete="username"></v-text-field>
            <v-text-field required prepend-icon="lock" v-model="loginPassword" name="password" label="비밀번호" autocomplete="current-password"
                :rules="passwordRules" 
                :type="showPassword ? 'text' : 'password'"
                :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                @click:append="showPassword = !showPassword">
            </v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey--text text--darken-1" @click="close">취소</v-btn>
          <v-btn :disabled="!valid" dark color="blue darken-3" @click="login">가입</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
</template>

<script>
import { ApiService } from "@/services/GuneApiService.js";

export default {
  data: () => ({
    valid: true,
    email: "",
    emailRules: [
      v => !!v || "이메일이 필요합니다",
      v => /.+@.+/.test(v) || "이메일 형식 맞나요?"
    ],
    showPassword: false,
    loginPassword: "",
    passwordRules: [
      v => !!v || "비밀번호 필요",
      v => (v && v.length >= 4) || "비밀번호는 4자리 이상"
    ]
  }),
  props: {
    dialog: Boolean
  },
  methods: {
    close() {
      this.$refs.form.reset();
      this.$emit("update:dialog", false);
    },
    showSingup() {
      this.$refs.form.reset();
      this.$emit("update:dialog", false);
    },
    login() {
      if (this.$refs.form.validate() === false) {
        return;
      }

      ApiService()
        .post("/auth/signup", {
          email: this.email,
          pw: this.loginPassword
        })
        .then(res => {
          alert("회원 가입 완료");
          this.$store.commit("setAuth", res.data);
          this.$emit("update:dialog", false);
        })
        .catch(function(err) {
          alert("회원가입 실패 :" + err.response.data.message);
        });
    }
  }
};
</script>